<!-- 업체 선택용 공통 팝업 -->
<template>
    
  <div class="pagination-container">
    <div class="pagination">
        <button v-if="bottompage > pagelimit" class="page-button" @click="prevrun()">◀</button>
        <template v-for="n in subpage" :key="n.id">
          <button class="page-button" @click="loadpagerun(bottompage-1+n)"
            :class="page == bottompage-1+n ? 'active' : ''"
            >
            {{bottompage-1+n}}
          </button>
        </template>
        <button v-if="bottompage+pagelimit < maxpage" class="page-button" @click="nextrun()">▶</button>
    </div>
  </div>

</template>

<script>
    export default {
        
        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
          pagelimit:{
            type:Number,
            default(){
              return 10
            }
          }
        },

        watch:{
          totalcnt:function(v1, v2){
            this.totalcnt = v1;
          },
        },

        data: ()=> ({
          //필수 페이징 파라메터
          page : 1,
          maxpage : 0,        //전체 페이지 개수
          startpage : 1,      //시작 인덱스
          bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
          subpage : 1,        //하단 페이징 번호의 종료점을 계산하기 위한 변수
        }),

        methods: {

          makepaging(totalcnt, pagerow){

            var div1 = totalcnt / pagerow; 
            var div2 = totalcnt % pagerow;
            if(div2 == 0){  
                this.maxpage = parseInt(div1);    
            }else{
                this.maxpage = parseInt(div1+1);
            }
            //console.log("makepaging : " + totalcnt + " / " + pagerow +" / " + this.page + " / " + this.maxpage);

            //이미 page값은 있는 상태
            this.bottompage = (parseInt((this.page-1)/this.pagelimit) * this.pagelimit)+1;
            //console.log("bottompage : " + this.bottompage);
            
            this.subpage = this.maxpage - this.bottompage >= this.pagelimit ? this.pagelimit : this.maxpage - this.bottompage+1;
            //console.log("maxpage : " + this.maxpage + " / subpage " + this.subpage + " / bottompage " + this.bottompage + " / limit : " + this.pagelimit);

          },

          //외부에서 현재 페이지 번호 동기화 처리 - 현재 페이지 번호 구분하기 위함
          setpage(pagenum){
            this.page = pagenum;
          },

          loadpagerun(pagenum){
            this.$emit('loadpage', pagenum);
          },
          
          prevrun(){
            this.bottompage = this.bottompage - this.pagelimit >= 1 ? this.bottompage - this.pagelimit : 1;
            this.subpage = this.maxpage - this.bottompage >= this.pagelimit ? this.pagelimit : this.maxpage - this.bottompage+1;
            var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
            this.$emit('loadpage', temp_page);
          },

          nextrun(){
            this.bottompage = this.bottompage + this.pagelimit <= this.maxpage ? this.bottompage + this.pagelimit : this.maxpage;
            this.subpage = this.maxpage - this.bottompage >= this.pagelimit ? this.pagelimit : this.maxpage - this.bottompage+1;
            var temp_page = this.bottompage;
            this.$emit('loadpage', temp_page);
          },

        }

    }
</script>

<style scoped>
  /* 페이지네이션 영역 */
  .pagination-container {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}

.pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.page-info {
    margin: 0 12px;
    font-size: 13px;
    color: #5f6368;
    text-align: center;
}

.page-button {
    min-width: 32px;
    height: 32px;
    border: none;
    border-radius: 4px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    color: #5f6368;
    transition: all 0.2s;
}

.page-button:hover {
    background: #f8f9fa;
}

.page-button.active {
    background: #7C4DFF;
    color: white;
}

.page-button.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}


</style>